import { DISPLAY_TOPIC_SUMMARY_INFO, UPDATE_TOPIC_SUMMARY_INFO } from '../../../types/conversations/plugins'
import { apiConversation } from 'api'

/**
 * Display topic summary info container
 * @param {String} userId
 * @param {Boolean} isOpen
 * @param {Boolean} [isLoading=false]
 */
const displayTopicSummaryInfo = (userId, isOpen, isLoading = false) => {
  return {
    type: DISPLAY_TOPIC_SUMMARY_INFO,
    isOpen,
    userId,
    isLoading,
  }
}

/**
 * Update topic summary info
 * @param {String} userId
 * @param {array} topics=[]
 */
const updateTopicSummaryInfo = (userId, topics = []) => {
  return {
    type: UPDATE_TOPIC_SUMMARY_INFO,
    userId,
    topics,
  }
}

/**
 * Close collapse for topic summary info plugin
 */
const close = () => async (dispatch, getStore) => {
  const { activeUser } = getStore().tabs
  dispatch(displayTopicSummaryInfo(activeUser, false))
}

/**
 * Open collapse for topic summary info plugin
 */
const open = () => async (dispatch, getStore) => {
  const { activeUser } = getStore().tabs
  dispatch(displayTopicSummaryInfo(activeUser, true))
}

/**
 * Get topic summary info
 */
const generateTopicSummary = (hasTopics = false) => async (dispatch, getStore) => {
  const { activeUser } = getStore().tabs
  const { conversations } = getStore()
  const currentConversation = conversations[activeUser]
  const conversationId = currentConversation?.user?._id
  dispatch(displayTopicSummaryInfo(activeUser, true, true))
  try {
    const { data } = await apiConversation.plugins.topicSummary.generateTopicSummary({ conversationId })
    if (data && (!hasTopics || data?.isUpdate)) {
      listTopicSummary(conversationId)(dispatch, getStore)
    } else if (data && !data?.isUpdate && hasTopics) {
      dispatch(displayTopicSummaryInfo(activeUser, true))
    }
  } catch (error) {
    console.error('error: ', error)
  }
}

/**
 * List topic summary info
 */
const listTopicSummary = (userId = null) => async (dispatch, getStore) => {
  let conversationId = userId
  const { activeUser } = getStore().tabs
  const { conversations } = getStore()
  const currentConversation = conversations[activeUser]
  if (!conversationId) {
    conversationId = currentConversation?.user?._id
    if (!conversationId) {
      return
    }
  }
  dispatch(displayTopicSummaryInfo(activeUser, true, true))
  try {
    const { data } = await apiConversation.plugins.topicSummary.listTopicSummary({ conversationId, pageSize: 1 })
    if (data) {
      if (data.success) {
        dispatch(updateTopicSummaryInfo(activeUser, data.topics || []))
      }
    }
  } catch (error) {
    console.error('error: ', error)
  }
}

export default {
  close,
  open,
  generateTopicSummary,
  listTopicSummary,
}
